import * as React from 'react'
import { Box, Dialog, DialogContent, Typography } from '@mui/material'
import NormalText from 'common/Typography/NormalText'

export type ClickListCellProps<T> = {
  items?: T[]
  getItemLabel: (item: T) => string

  title: string
  label?: string

  separator?: string
  emptyText?: string
  underline?: boolean
}

export default function ClickListCell<T>({
  items = [],
  getItemLabel,
  title,
  label = 'Items',
  separator = ' | ',
  emptyText = '-',
  underline = true
}: ClickListCellProps<T>) {
  const [open, setOpen] = React.useState(false)

  if (!items || items.length === 0) return <NormalText>{emptyText}</NormalText>

  const firstLabel = getItemLabel(items[0])
  const extra = items.length > 1 ? ` +${items.length - 1}` : ''
  const allLabels = items.map(getItemLabel).join(separator)

  return (
    <>
      <NormalText
        onClick={(e) => {
          e.stopPropagation()
          setOpen(true)
        }}
        style={{
          cursor: 'pointer',
          textDecoration: underline ? 'underline' : 'none'
        }}
      >
        {firstLabel + extra}
      </NormalText>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth='sm'
        fullWidth
        PaperProps={{ sx: { borderRadius: 2, p: 2 } }}
      >
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant='h5' sx={{ fontWeight: 700, mb: 2 }}>
            {title}
          </Typography>

          <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
            <Typography sx={{ fontWeight: 600 }}>{label}:</Typography>
            <Typography>{allLabels}</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}
